import * as React from 'react';
import { SelectionInputProps } from '../classes/index';

export interface DropdownProps extends SelectionInputProps {
    isRequired?: boolean;
}

const controlledDropdownView: React.StatelessComponent<DropdownProps> = (props) => {
    return (
        <div className={`${props.customClass} dropdown-container`}>
            <label className={props.hideLabel ? "hidden" : ''} htmlFor={props.htmlId}>{props.label} {props.isRequired ? <span className="required-indicator" title="Required Field"></span> : ""}</label>
            <select className={`${props.showError ? "input-validation-error" : null}`} id={props.htmlId} onChange={props.onChange} value={props.selectedValue ? props.selectedValue : ""}>
                {
                    props.options.map((option, idx) => <option key={`${props.htmlId}-${option.value}`} value={option.value} disabled={option.value === "disabled"}>{option.text}</option>)
                }
            </select>


        </div>
    );
};

export default controlledDropdownView;


// WEBPACK FOOTER //
// ./app/views/controlled-dropdown.tsx